<nav aria-label="breadcrumb" role="navigation">
    <ol class="breadcrumb">
        <li class="breadcrumb-item">
            <a [routerLink]="[ '' ]"><i class="fa fa-home"></i></a>
        </li>
        <li class="breadcrumb-item" routerLinkActive="active" aria-current="page">search</li>
    </ol>
</nav>